import React from 'react'
import PropTypes from 'prop-types'

import { LoadingModal } from '../../components/loading/modal'
import useChangeSubscriptionScreen from './hooks/use-change-subscription-screen'
import { direction } from './constants'

const UpgradeSubscriptionModal = ({ modalCloseTarget }) => {
  const screen = useChangeSubscriptionScreen(
    direction.upgrade,
    modalCloseTarget
  )
  return screen || <LoadingModal />
}

UpgradeSubscriptionModal.propTypes = {
  modalCloseTarget: PropTypes.string
}

export default UpgradeSubscriptionModal
